export default __webpack_public_path__ + "static/media/thumbnail2.7f7c65d8.jpg";